export default {
sets: `Sets`,
stats: `Statistics`,
discover: `Discover`,
guides: `Guides`,
settings: `Settings`,
unsupportedBrowserBody: `Flashcards does not support this browser. Download the latest version of Chrome or Opera, or download our iPhone, or Android Application`,
unsupportedBrowserTitle: `Unsupported Browser`,
noData: `No data to show`,
contactUsTitle: `We love hearing how our users use our app, and how we can improve. Drop us a message with any queries, such as feature requests, or bug reports`,
rateAppStore: `Rate in AppStore`,
rateGoogle: `Rate in Google Play`,
close: `Close`,
shareFriends: `Share with friends`,
noCardsQ: `Don't have any flashcards?`,
noCardsS: `Select from our collection to get started`,
suggestSet: `Suggest Set`,
createOwn: `Create Your Own`,
search: `Search`,
loading: `Loading`,
words: `Words`,
downloads: `Downloads`,
export: `Export`,
import: `Import`,
importing: `Importing... Don't close the app`,
importPreview: `Import Preview`,
howQuizlet: `How to import from Quizlet`,
cards: `Cards`,
importPreviewStatus: `__ terms are ready to be appended to the existing ___ cards`,
importPaste: `Paste your cards into the above textarea`,
setTotalLimitReached: `You can only have 3000 cards in a studyset`,
studying: `Studying`,
learnt: `Learnt`,
mastered: `Mastered`,
new: `New`,
noTerm: `No Term`,
noDef: `No Definition`,
cardSaved: `Card Saved`,
reviews: `Reviews`,
practices: `Practices`,
flashcards: `Flashcards`,
alerts: `Alerts`,
corrects: `Corrects`,
mistakes: `Mistakes`,
reviewCycle: `Review Cycle`,
reviewsLeft: `Reviews Left`,
lastReview: `Last Review`,
nextReview: `Next Review`,
hideHistory: `Hide Full History`,
showHistory: `Show Full History`,
strength: `Strength`,
star: `Star`,
image: `Image`,
tag: `Tag`,
added: `added`,
removed: `removed`,
reviewedFrom: `Reviewed from __ `,
notifications: `Notifications`,
reviewedPractice: `Reviewed __ by ___ practice`,
successfully: `successfully`,
unsuccessfully: `unsuccessfully`,
termUpdated: `Term updated`,
defUpdated: `Definition updated`,
flashcardCreated: `Flashcard Created`,
dropboxImage: `You have to enable Dropbox sync to add images`,
deleteImgConfirm: `Are you sure you want to delete this image?`,
uploading: `Uploading`,
save: `Save`,
uploadImageFail: `Failed to upload image`,
imageUploaded: `Image Uploaded`,
setNotFound: `Studyset not found!`,
notEnoughCards: `Not enough cards!`,
of: `__ of ___`,
on: `On`,
off: `Off`,
auto: `Automatic`,
manual: `Manual`,
pronounce: `Pronounce`,
practiceCompleted: `You have completed this practice`,
closePractice: `Close Practice`,
autoplay: `Autoplay`,
secFlipSecNext: `__ sec flip, ___ sec next`,
autopronounce: `Autopronounce`,
onlyTerm: `Only Term`,
onlyDef: `Only Definition`,
termAndDef: `Term and Definition`,
savePractice: `Save practice?`,
continueLater: `Continue Later`,
deletePractice: `Delete Practice`,
term: `Term`,
def: `Definition`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Review Goal`,
dailyGoal: `Daily Goal`,
edit: `Edit`,
setUp: `Set Up`,
noRecentPractice: `You don't have any recent practices`,
continueLastReview: `Continue Last Review`,
dueCards: `Due Cards`,
studyNow: `Study Now`,
newCards: `New Cards`,
terms: `terms`,
defs: `definitions`,
validCardsOf: `Only __ of the selected ___ cards can be practiced, as the others are either missing the term or the definition`,
reviewCards: `Review Cards`,
customizePractice: `Customize Practice`,
next: `Next`,
iWasRight: `I was right`,
printProAlert: `Please purchase pro subscription to print more than 20 flashcards`,
print: `Print`,
printWidth: `Term-Def Width`,
printFont: `Font Size`,
printBorder: `Border`,
printMargin: `Page Margin`,
printPadding: `Word Padding`,
preparingFile: `Preparing file`,
notificationsBlocked: `Notifications are not enabled, you enable notifications from your phone's settings`,
ranOutOfWords: `Ran out of cards, restart the practice to start over`,
ranOutOfWordsShort: `Run out of words`,
ranOutOfWordsBody: `Open the app to schedule new words`,
proIncreaseNotifications: `You can increase the total notifications from 10 to 50 in the premium version.`,
schedule: `Schedule`,
frequency: `Frequency`,
mode: `Mode`,
tM1: `1 minute`,
tM2: `2 minutes`,
tM5: `5 minutes`,
tM10: `10 minutes`,
tM15: `15 minutes`,
tM30: `30 minutes`,
tH1: `1 hour`,
tH2: `2 hours`,
termPassive: `Term Passive`,
termActive: `Term Active`,
defPassive: `Def Passive`,
defActive: `Def Active`,
scheduledIn: `Scheduled in __ mins`,
scheduledAlertsProT: `Increase schedulable alerts with Pro`,
scheduledAlertsProB: `You can increase the scheduled alerts from 10 to 50 with the pro package`,
seeFeatures: `See Features`,
defAndTerm: `Definition and Term`,
termHoldDef: `Term, hold to reveal definition`,
defHoldTerm: `Definition, hold to reveal term`,
notificationType: `Notification Type`,
copyToClipboard: `Copy to clipboard`,
enterAuthCode: `Please enter your authorization code`,
invalidCode: `Invalid code provided`,
copied: `Copied!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Tap to discover all the premium features to learn more efficiently in your own pace`,
promoBtn: `DISCOVER ALL FEATURES`,
setDropboxH2: `Dropbox Sync`,
setDropboxPOff: `Enable Dropbox Sync to keep your sets, flashcards, tags, and progress backed up and updated across all your devices.`,
setDropboxPOn: `Your data is backed up and synced across your devices.`,
setDropboxBtn: `Sync`,
status: `Status`,
syncNow: `Sync Now`,
contact: `Contact`,
contactUs: `Contact Us`,
useFromBrowser: `Use from the browser`,
useFromBrowserMsg: `Visit flashcardsmadesimple.com on your computer and restore your cards and licence by enabling Dropbox sync`,
termsPrivacy: `Terms & Privacy`,
dailyReviewGoal: `Daily Review Goal`,
numberTerms: `Number of Terms`,
selectTerm: `Select with term hint`,
selectDef: `Select with definition hint`,
pronounceTerm: `Pronounce with term hint`,
pronounceDef: `Pronounce with definition hint`,
typeTerm: `Type with term hint`,
typeDef: `Type with definition hint`,
quizTypes: `Preferred Quiz Types`,
spacedRepetition: `Spaced Repetition Schedule`,
spacedRepetitionP: `Spaced repetition allows you to master words with less efforts by incrementally spacing out the review time. The default schedule is 1-3-7-15-31 days, but you can set up a custom one as well.`,
spacedRepetionScheduleItem: `__ days after ___ review (Day ____)`,
atLeastOneSchedule: `At least one schedule is required`,
revisionLimitReached: `You reached the maximum revsision count`,
addReviewSchedule: `Add new review schedule`,
autoMarkLearnt: `Auto mark learnt after`,
autoMarkMastered: `Auto mark mastered after`,
tagManager: `Tag Manager`,
delete: `Delete`,
addTag: `Add new tag`,
tagDeletionH: `Tag Deletion`,
tagDeletionP: `Are you sure you want to delete this tag?`,
cancel: `Cancel`,
daysAfterLastReview: `Days after last review`,
linkDropbox: `Link Dropbox`,
startSync: `Start Sync`,
starred: `Starred`,
images: `Images`,
tags: `Tags`,
types: `Types`,
activeDays: `Active Days`,
inactiveDays: `Inactive Days`,
longestStreak: `Longest Streak`,
dailyGoalsCompleted: `Daily Goals Completed`,
dailyGoalsFailed: `Daily Goals Failed`,
typePairs: `Type Pairs`,
reviewTypes: `Review Types`,
typePractice: `Type Practice`,
pronouncePractice: `Pronounce Practice`,
selectPractice: `Select Practice`,
notificationReview: `Notification Review`,
flashcardReview: `Flashcard Review`,
studyset: `Studyset`,
enterStudysetName: `Please enter a name for your studyset`,
studysetName: `Enter Set's Name`,
termType: `Term Type / Lang`,
defType: `Definition Type / Lang`,
exportCards: `Export Cards`,
importCards: `Import Cards`,
quiz: `Quiz`,
showingOutOfCards: `Showing __ out of ___ cards`,
showingAllCards: `Showing all cards, type into the above search bar or tap on any tags to filter`,
recording: `Recording`,
downloadSet: `Add to my Sets`,
addNewCard: `Add new Card`,
saveStudyset: `Save Study Set`,
studysetDeletionH: `Studyset Deletion`,
studysetDeletionP: `Are you sure you want to delete this studyset, this will also delete all contained cards.`,
cardDeletionH: `Card Deletion`,
cardDeletionP: `Are you sure you want to delete this card`,
cardLimitReached: `You can only have 3000 cards in a studyset`,
limitExceeded: `Limit exceeded`,
atLeastTenCards: `Add at least 10 cards to get started with the practices`,
searchInAll: `Search in all study sets`,
noMatch: `No match`,
atLeastThreeChars: `Enter at least 3 characters to search`,
noSets: `No sets`,
startingSync: `Starting sync`,
noSetsP: `Select from the below options to get started`,
startingSyncP: `We are getting your data from Dropbox, this might take a while`,
createNewStudyset: `Create new Studyset`,
restoreFromBackup: `Restore from Backup File`,
setStarterPacks: `Studyset Starterpacks`,
selectPracticeType: `Select practice type`,
noDueCards: `No due flashcards yet, flashcards that you have reviewed before will start showing up here after the selected spaced repetition schedule to help you master words with less effort and time`,
noNewCards: `No new cards to study`,
subscriptionH: `Buy Pro to enjoy all the features and to support the continious development.`,
buyLifetimePro: `BUY LIFETIME PRO FOR __`,
restorePurchase: `RESTORE PURCHASE`,
termsPrivacyC: `TERMS & PRIVACY POLICY`,
licenceShare: `If you purchased a licence from another device you can share it with this device by enabling Dropbox Sync on both devices`,
enterTagName: `Enter the name of the tag`,
invalidName: `Invalid name`,
create: `Create`,
name: `Name`,
tagName: `Name of your tag`,
color: `Color`,
back: `Back`,
rowSeparator: `Row Separator`,
termDefSeparator: `Term - Def Separator`,
output: `Output`,
inputCards: `Input Cards`,
review: `Review`,
language: `Language`,
archiveReversible: `Archive (Reversible from Settings)`,
deletePermanent: `Delete (Irreversible)`,
archivedCards: `Archived Cards`,
masteredCards: `Mastered Cards`,
due: `Due`,
reviewed: `Reviewed`,
markReviewed: `Mark Reviewed`,
markMastered: `Mark Mastered`,
forXYCards: `for __ ___ cards`,
createdAtSortBy: `Creation Date`,
lastReviewedSortBy: `Last Review Date`,
reviewCountSortBy: `Number of Reviews`,
strengthSortBy: `Strength`,
termSortBy: `Alphabetical Term`,
definitionSortBy: `Alphabetical Def.`,
ascSortBy: `Ascending`,
descSortBy: `Descending`,
featureSync: `Study anything, anywhere, anytime with your flashcards  synced across all your devices`,
featureSpacedrepetition: `Look into your overall progress, and get back to practicing what you need to practice`,
featureNotifications: `Supercharge your learning without even opening the app with flexible notifications`,
featureFlashcards: `Autoplay flashcards when your hands or eyes are busy, but you still have unused attention`,
featureQuiz: `Match, spell out, listen or select to practice your flashcards`,
featureStats: `Gain better insight into your cards and results, and search across all your flashcard sets`,
featureImport: `We will never store any data of you, and you can export and import all your data easily`,
featurePrint: `Get some learning done by printing your flashcards, and DIY your own studying rig`,
splashIntro: `Study all your flashcards anywhere in your pace and style`,
selectSortOrder: `Sort Order`,
selectSortProp: `Sort Property`,
applyFilters: `Apply Filters`,
selectSetType: `What do you want to practice?`,
getStarted: `Get Started`,
tapToUnarchive: `Tap on the cards you want to unarchive`,
untitled: `Untitled`,
sortHintNew: `you will see the cards that were created the longest time ago first`,
sortHintDue: `you will see cards that have been due for the longest first`,
sortHintOther: `you will see cards that have not been studied the longest first`,
flashcardsWhen: `, when your hands or eyes are busy, even while listening to music / podcasts`,
notificationsWhen: `, for when you are out and about and just want quick study bits`,
quizWhen: `, for when you can pay full attention for studying, to master your cards`,
features: `Features`,
ratings: `Ratings`,
notificationDailyCatchUpBody: `New: __, Due: ___, Studying: ____, Learnt: _____, Mastered: ______`,
notificationDailyCatchUpTitle: `Daily Catchup`,
reviewedJN: `Reviewed Just Now`,
customUpdated: `Custom Text Updated`,
customTextField: `Synonyms, examples, etc.`,
field: `Field`,
link: `Link`,
backToParentCard: `Back to parent card`,
discard: `Discard`,
failedImageLoad: `Failed to load image, make sure you are connected to the internet`,
printDIYLabel: `DIY your own creative paper based study setup, share with us your creation, and get featured in the app.`,
reviewGraphChart: `Review Frequency`,
langNotSet: `Language not set`,
pronouncationLangInfo: `To enable pronunciation you have to select the term and definition language. A speaker sign will appear next to the languages if your device supports that language`,
clearFilters: `Clear Filter`,
subFreeUnlimited: `Unlimited Studysets, Flashcards, Practices, Search, and Syncing`,
customFields: `Custom Fields`,
subLinks: `Card Links`,
subPrint: `Print / Studyset`,
subNotifications: `Notification before having to open app`,
subCardsStudysets: `Cards / Studyset`,
subRevisionCycles: `Custom Revision Cycles`,
subscriptionHEnd: `Upgrading to pro shows us that you find our hard work valuable and gives us encouragement and coffee to keep on improving and creating new amazing things.`,
subFree: `Free`,
subPro: `Pro`,
guideSpacedRepetition: `How does Spaced Repetition work & Practice Types`,
guideSearch: `Searching & Filtering`,
guideSync: `Enable Backup and Sync across your devices`,
guidePronunciation: `Enable pronunciations`,
guideImport: `Importing cards from exiting sources`,
guideAccess: `Who has access to my data?`,
guideData: `What data do we collect?`,
guideContact: `Need help with anything else? Write to us`,
arrowStrength: `Set how well you know this card`,
arrowImage: `Add images`,
arrowField: `Add Additional Custom Text Fields`,
arrowTag: `Attach Tags`,
arrowStar: `Mark as Favorite`,
arrowLink: `Link to other cards`,
arrowGoal: `Set up a daily review goal for yourself`,
arrowDue: `Study words that are due to be reviewed`,
arrowNew: `Study cards that have not been reviewed yet`,
arrowMastered: `If you don't have any due or new cards you can review mastered cards to keep them mastered`,
arrowImport: `Import your existing flashcards`,
arrowNewCard: `Add a new flashcards`,
dropboxStep1: `1. Get access code from Dropbox by logging in`,
dropboxStep1Btn: `Log in with Dropbox`,
dropboxStep2: `2. Enter access code below`,
dropboxStep2Input: `Enter Code Here`,
dropboxStep3: `3. Start Sync`,
alreadyLinked: `Already Linked, tap to Unlink`,
selectCardsToLink: `Select Cards to Link`,
unsupportedLangP: `Select a language that supports pronounciation from the set's settings`,
links: `Links`,
emailUs: `Send us an Email`,
whatsappUs: `WhatsApp Us`,
printMinHeight: `Min. row height`,
exportType: `Export File Type`,
generateFileText: `Generate File`,
generatatingFile: `Generating File`,
verySmall: `Very Small`,
small: `Small`,
normal: `Normal`,
big: `Big`,
veryBig: `Very Big`,
repeatNTimes: `Repeat __ times`,
pause: `Pause`,
for: `for`,
say: `Say`,
defShort: `Defin.`,
times: `times`,
autoplayPreferences: `Set Autoplay Preferences`,
autoPlay1: `Pause after previous word`,
autoPlay2: `Number of term pronounciations`,
autoPlay3: `Pause before revealing definition`,
autoPlay4: `Number of definition pronounciations`,
autoPlay5: `Pause before showing next word`,
autoPlay6: `Repeat the same flashcard`,
startAutoPlay: `Start Autoplay`,
autoPlayOffConfirm: `Turn off autoplay to enable manual controls`,
turnOff: `Turn Off`,
keepPn: `Keep On`,
foundIn: `Found in __`,
repeat: `repeat`,
stop: `Stop`,
listenInBreak: `Did you know? You can listen to Music / Podcasts in breaks`,
contextSearch: `Context Search`,
contextSearchText: `Get examples of how __ used in different sentences`,
transalteSearch: `Translate`,
translateSearchText: `Translate __ to ___`,
synonymSearch: `Synonym Search`,
synonymSearchText: `Search for synonyms of __`,
selectToAdd: `Select the results you want to add to this card`,
addToCard: `Add selected to card`,
hideFromPractice: `Hide in Round`,
setLanguageRequired: `Please select the language of the terms and definitions in the studyset details`,
fieldNeedsText: `Enter something into this field before searching`,
possibleDupe: `Possible Duplicate`,
loadNextXCards: `Load next __ cards`,
repeatPractice: `Repeat these __ cards`,
keepScreenOnInfo: `You might have to adjust your auto-lock setting, to keep the screen on while autoplaying.`,
siteLoginH2: `SFM Account`,
siteLoginP: `You can use your Flashcards made Simple account to share your flashcards with your friends, your students or the whole community.`,
logOut: `Log Out`,
logIn: `Log In`,
createAccount: `Create new Account`,
signUp: `Sign Up`,
username: `Username`,
email: `Email`,
password: `Password`,
networkError: `Network Error`,
fillAllDetails: `Please fill out all the details`,
noUserWithDetails: `No user found with the entered details`,
userAlreadyExists: `The given email or username already exists`,
signUpOrLoginToCont: `Sign up or log in to continue?`,
atLeastOneCardToShare: `At least one card is required to share`,
publishingStudyset: `Publishing Studyset`,
updatesDetected: `Updates detected, do you want to proceed updating local data? (Deleted: __, Updated: ___, New: ____)`,
updatesApplied: `Updates applied`,
alreadyUpToDate: `Already up to date`,
practiceTypeArrow: `Discover different ways of praciting`,
share: `Share`,
sharingModalIntro: `Share your flashcards in this set with your friends, your students or the whole community.`,
whatIsShared: `What is shared`,
whatIsNotShared: `What is NOT shared`,
whatIsSharedText: `Set name, Set term language, definiton language, All included Cards with Terms, Definitions, Custom text fields, and images`,
whatIsNotSharedText: `Any card strengths, stars, links, tags, and your review history`,
checkForSharedUpdates: `Check for Updates from Creator`,
fetchUpdates: `Fetch updates`,
youSharedStudyset: `You Shared this Studyset`,
publishChanges: `Save & Publish Changes`,
redeem: `Redeem`,
noAds: `No Ads`,
dupeDetection: `Duplicate Detection`,
coffeeFeature: `Coffee, to help us develop more features`,
shareLink: `Share Link`,
coffeeForUs: `You will get a lifetime licence for only __, which gives Emily 6 coffees, Dominik 3 coffees, and Russ 3 coffees, which will fuel us for about 39 hours to make this app event better`,
sharingCards: `Sharing Cards`,
published: `Published`,
alreadyHaveAccount: `Already have an account?`,
notAlreadyHaveAccount: `Don't have an account yet?`,
startPractice: `Start Practice`,
selectQuizTypes: `Select Quiz Types`,
correct: `Correct`,
incorrect: `Incorrect`,
yes: `Yes`,
no: `No`,
levelSilver: `Silver Level __`,
levelGold: `Gold Level __`,
levelPlatinum: `Platinum Level __`,
levelDiamond: `Diamond Level __`,
levelJade: `Jade Level __`,
reviewsLeftGoal: `__ reviews for Daily Goal`,
dailyGoalAchieved: `Daily Goal Achieved`,
share: `Share`,
rateApp: `Rate App`,
allStats: `All Stats`,
reviewTimeError: `Timeout After Error`,
reviewTimeCorrect: `Timeout After Correct`,
pronounceTermAfterReview: `Pronounce Term after Review`,
pronounceDefinitionAfterReview: `Pronounce Definition after Review`,
practice: `Practice`,
notificationsScheduledInfo: `__ notifications have been scheduled, you can close the app now`,
wellDone: `Well Done`,
keepItUp: `Keep It Up`,
youRock: `You Rock`,
niceOne: `Nice One`,
lnSelect: `Select Language`,
sampleData: `No reviews, showing sample data`,
reviewFreq: `Review Frequency`,
selectPractice: `Practice: Select`,
spellPractice: `Practice: Spell`,
connectPractice: `Practice: Connect`,
languages: `Languages`,
languagesPairs: `Language Pairs`,
shareArrow: `Share set with friends, students or the whole community`,
cardsPerRound: `Cards / Round`,
showAll: `Show All`,
supportedLangsVary: `Supported languages vary`,
practiceWithoutSave: `Practice not saved`,
practiceWithoutSaveBody: `You haven't added this studyset to your collection, do you want to add it now to save your study progress?`,
saveSetNow: `Save Cards to you Collection`,
continueWithoutSaveSave: `Start Practice without save`,
createdBy: `Created by`,
setSavedToYourCollection: `Study set saved to your collection`,
accountBackupDisclaimer: `Please note that this account can only be used for sharing studysets with others, and CANNOT be used to back up or sync your studysets or flashcards. To sync and backup all your data please use Dropbox Sync`,
syncEnabled: `Synchronization Enabled, fetching your content in progress`,
searchAllSets: `Search study sets from other users`,
anyLanguage: `Any Language`,
trendingIn: `Trending in`,
manualBackups: `Manual Backup`,
manualBackupCreate: `Create manual backup`,
confirmManualImport: `Are you sure you want to replace all current data with this backup? This is only recommendded on new devices without any data`,
importFromManualBackup: `Import from backup`,
imgOfflineSets: `Auto-download images for offline learning`,
unsupportedDeviceCache: `This feature is only available from the iOS or Android app`,
shareChanges: `Share __ changes`,
publiclySearchable: `Searchable by users`,
description: `Description`,
restoreFromDropboxBackup: `Restore from Dropbox Backup`,
imageCacheStudysetSub: `[iOS & Android only] Download Image for offline studying`,
keywordsOrLangNeeded: `You have to enter some keywords, or one language`,
dropboxAlreadyLinked: `Dropbox account is already linked`,
noSetUpdateAccess: `You don't have access to edit this study set.`,
confirmSetOwnerLogin: `If you are sure that you are the owner, then try logging in to your account again.`,
uninitedRestriction: `To save your progress, first you have to add this studyset to your collection`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Failed to consolidate storage`,
consolidateStorageDone: `Storage Consolidate, please allow up to an hour for Dropbox to finish removing old files before you log in on a new device.`,
consolidatingStorage: `Consolidating Storage...`,
deleteAccount: `Delete Account`,
consolidateStorageDescription: `This operation will reindex your backups files, so setting up a new devices will be faster`,
consolidatingStorageConfirm: `Make sure all your changes have already finished syncing, don't sync other devices while this process is taking place. Do you want to continue?`,
consolidateStorage: `Consolidate Storage`,


}